import { Link } from "react-router-dom";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function Footer() {
  const { isPrelaunch } = useSiteSettings();
  return (
    <footer className="border-t border-zinc-800 mt-24 bg-[#050505]">
      <div className="container-tight py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <img src="/interstate-pc-logo.jpg" alt="Interstate PC"
            className="h-14 w-auto mb-4" />
          <p className="text-sm text-zinc-500 max-w-md leading-relaxed">
            Computers, components and technology for home, business, school and gaming.
          </p>
          <div className="mt-4">
            <div className="font-mono text-[10px] tracking-widest text-zinc-500 uppercase">Sales & Support</div>
            <a href="mailto:sales@interstate-pc.com" data-testid="footer-email"
               className="text-sm text-[#FF5C00] hover:text-[#FF7A33] font-mono">
              sales@interstate-pc.com
            </a>
          </div>
        </div>
        <div>
          <div className="font-mono text-xs text-zinc-400 tracking-widest uppercase mb-3">Shop</div>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/catalog?category=laptops" className="hover:text-white">Computers &amp; Laptops</Link></li>
            <li><Link to="/catalog?category=gpus" className="hover:text-white">Components</Link></li>
            <li><Link to="/catalog?category=monitors" className="hover:text-white">Monitors &amp; Peripherals</Link></li>
            <li><Link to="/catalog?category=desktops" className="hover:text-white">Business &amp; Workstations</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-xs text-zinc-400 tracking-widest uppercase mb-3">Company</div>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/policies/shipping" className="hover:text-white">Shipping Policy</Link></li>
            <li><Link to="/policies/returns" className="hover:text-white">Return Policy</Link></li>
            <li><Link to="/policies/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/policies/terms" className="hover:text-white">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-4">
        <div className="container-tight flex flex-col md:flex-row justify-between gap-2 font-mono text-xs text-zinc-600">
          <div>© 2026 Interstate PC · Technology &amp; Components Network</div>
          <div className="tracking-widest">{isPrelaunch ? "ONLINE CATALOG · ORDERING OPENS SOON" : "SECURE CHECKOUT · STRIPE · SSL"}</div>
        </div>
      </div>
    </footer>
  );
}
